module.exports = __webpack_public_path__ + "media/music/09995475180591a6c64c8744fbfdf4d8.mp3";